import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, ref, watch, computed } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import { TableOpt } from '@/components/cmTable/types'
import { PopupViewService, DetailQueryParams } from './popup-view/popup-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import TerminalIconName from '@/views/dashboard/_components/terminal-icon-name/terminal-icon-name.vue'
import IPColumn from '@/views/dashboard/_components/ip-column/IPColumn.vue'
import { nextTick } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-detail-list',
  props: {
    softId: {},
    popupType: {}
  },
  setup(__props: any, { expose: __expose }) {

const { t } = useI18n()

const props = __props

const injector = useReflectiveInjector([PopupViewService])
const popupViewService = injector.get(PopupViewService)
const dataApi = popupViewService.fetchDetailList.bind(popupViewService)

const tableRef = ref()

const { refreshList } = useCmTableListRefresh(tableRef)
const queryParams = reactive<DetailQueryParams>({
  page: 1,
  limit: 20,
  sort: '',
  asc: false,
  soft_id: props.softId || -1,
  popup_type: props.popupType || 4
})

const tableOpt = computed<TableOpt>(() => ({
  bodyStyle: 'padding: 10px 16px',
  columns: [
    { prop: 'computer_name', label: t('popupIntercept.computerName'), type: 'COMPUTER', columnOpt: { minWidth: 180 } },
    { prop: 'user_mark', label: t('popupIntercept.registerUser'), columnOpt: { minWidth: 120 } },
    { prop: 'group_name', label: t('popupIntercept.groupName'), columnOpt: { minWidth: 120 } },
    { prop: 'ip', type: 'IP', label: t('popupIntercept.ipAddress'), columnOpt: { minWidth: 200 } },
    {
      prop: 'auto_intercept_switch',
      label: t('popupIntercept.autoIntercept'),
      formatter: (_row, val) => val === 1 ? t('popupIntercept.switchOn') : t('popupIntercept.switchOff'),
      columnOpt: { minWidth: 100 }
    }
  ],
  rowKey: 'device_id',
  path: 'list',
  height: '100%'
}))

watch(() => [props.softId, props.popupType], async([newSoftId, newPopupType]) => {
  queryParams.soft_id = newSoftId || -1
  queryParams.popup_type = newPopupType || 4
  queryParams.page = 1
  await refreshList()
}, { immediate: true })

__expose({
  tableRef
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    tableOpt: tableOpt.value,
    firstLoading: false,
    api: _unref(dataApi),
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams) = $event)),
    pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    }
  }, null, 8, ["tableOpt", "api", "modelValue"]))
}
}

})